import { createComponentPreviewMapperModel } from '@wix/editor-elements-integrations';
import { composeMapper } from '@wix/editor-elements-preview-utils';
import { PreviewWrapperProps } from '@wix/editor-elements-types';
import {
  CustomElementComponentDefinition,
  CustomElementComponentProps,
} from '../CustomElementComponent.types';
import { props as viewerPropsMapper } from './CustomElementComponent.mapper';

const props = composeMapper<
  PreviewWrapperProps<CustomElementComponentProps>,
  CustomElementComponentDefinition
>()(
  viewerPropsMapper,
  { add: ['componentViewMode', 'compLayout'] },
  (resolver, deps, carmiData) => {
    const viewerProps = resolver(deps, carmiData);
    const { componentViewMode, compLayout } = deps;
    const { width, height } = compLayout;

    return {
      ...viewerProps,
      previewWrapperProps: {
        componentViewMode,
        containerSizes: { width, height },
      },
    };
  },
);

export default createComponentPreviewMapperModel({
  props,
});
